import type { Tokens } from '../../../../theming/types'
import type { MenuUIProps } from '..'

export default (config: {
  props: Pick<MenuUIProps, 'positionStatic' | 'glass'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  const glassFrost = props.glass === 'frost'

  function getBackgroundColor() {
    if (props.positionStatic) {
      return undefined
    }
    if (glassFrost) {
      return tokens.bgColorGlassFrost
    }
    return tokens.bgColorDefault
  }

  function getShadow() {
    if (props.positionStatic) {
      return undefined
    }
    if (glassFrost) {
      // replace with glass low token when available
      return tokens.elevationLow
    }
    return tokens.elevationMedium
  }

  return {
    menuUIContainer: {
      border: glassFrost
        ? `${tokens.borderWidthS} solid ${tokens.borderColorSubtle}`
        : undefined,
      borderRadius: !props.positionStatic ? tokens.radiusSizeM : undefined,
      backdropFilter: glassFrost ? 'blur(8px)' : undefined,
    },

    menuUIBackground: {
      boxShadow: getShadow(),
      backgroundColor: getBackgroundColor(),
      border:
        !props.positionStatic && !glassFrost
          ? `${tokens.borderWidthXS} solid ${tokens.borderColorSubtle}`
          : 'none',
      borderRadius: !props.positionStatic
        ? // needed to remove the gap between this container and the wrapping container
          `calc(${tokens.radiusSizeM} - ${tokens.borderWidthXS})`
        : undefined,
      padding: tokens.spacingGap100,
    },

    menuUIMenuItems: {
      borderRadius: props.positionStatic ? tokens.radiusSizeM : undefined,
      padding: `${tokens.spacingGap100} 1px`,
    },
  } as const
}
